import { useState, useEffect } from "react";
import { Productbtn } from "../../../../../shared/services/interfacev2";
import { getProduct } from "src/shared/services/servicesv2";
import { errorHandling } from "src/shared/utils/errorHandling";

interface UseProductDataParams {
  deleted?: boolean;
  filteredTerm?: string;
  categoryID?: string;
  sortField?: string;
  order?: string;
}

export const useProductData = ({
  deleted = false,
  filteredTerm = "",
  categoryID,
  sortField,
  order,
}: UseProductDataParams) => {
  const [selectedProducts, setSelectedProducts] = useState<Productbtn[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (!categoryID) {
      setSelectedProducts([]);
      setLoading(false);
      return;
    }

    setLoading(true);

    // ✅ page & row passed as undefined
    getProduct(deleted, undefined, undefined, filteredTerm, categoryID, sortField, order)
      .then((res) => {
        setSelectedProducts(res.data.results || []);
      })
      .catch((err) => {
        errorHandling(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [deleted, filteredTerm, categoryID, sortField, order]);

  return { selectedProducts, loading };
};